import React, { useEffect } from "react";
import { getCommunityMembers } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const ParticipantsCommunities = ({ getCommunityMembers, communityMembers, period }) => {
  useEffect(() => {
    getCommunityMembers({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityMembers(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityMembers(payload);
  };

  return (
    <DataTable
      preset="participantsCommunities"
      data={{
        docs: communityMembers?.docs || [],
        totalPages: communityMembers?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  communityMembers: state.appCommunities.communityMembers,
});

const mapDispatchToProps = (dispatch) => ({
  getCommunityMembers: (payload) => dispatch(getCommunityMembers(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantsCommunities);
